export default {"src":"/_next/static/media/MEXC.593b9371.svg","height":19,"width":121,"blurWidth":0,"blurHeight":0};